/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_sharetrip.js                                                               */
/**********************************************************************************************************************/

/* Controller GUI */
HafasWebapp.prototype.Controller.ShareTrip = {
    currentConnection: null,
    currentOverlay: null,
    currentShortLink: null,
    currentConnectionText: "",
    currentConnectionTitle: "",
    currentLocationShareUseTime: true,
    currentLocationShareTime: {
        date: null,
        time: null,
    },

    /**
     * create a model for sharing function
     *
     * @method createModel
     * @param {string} shareResultSubject - contains the subject for sharing
     * @param {string} shareResultText - contains text for sharing
     * @param {string} [shareUrl] - optional, contains an url
     */
    createModel: function (shareResultSubject, shareResultText, shareUrl) {
        if (shareResultSubject && (shareResultText || shareUrl)) {
            var model = {header: shareResultSubject};
            if (shareResultText !== undefined && shareResultText !== null) {
                model.text = shareResultText;
            }
            if (shareUrl !== undefined) {
                model.url = shareUrl;
            }
            return model;
        } else {
            console.log("Text und Subject not defined");
        }
    },
    /**
     * prepare requests to retrieve the texts / links for the configured share options
     *
     * @method toggleFeature
     * @param {String} shareType - passes the shareType e.g. "location" or "trip" to toggle the individual section
     */
    toggleFeature: function(shareType){
        Hafas('[data-share-content]',true).forEach(element => Hafas.Util.gui.setVisibility(element,false));

        // Show feature that the user toggled to
        var shareContentArea = Hafas('[data-share-content="' + shareType + '"]',false);
        Hafas.Util.gui.setVisibility(shareContentArea,true);

        // Check if shareType is "location", if so generate the links for the share location feature
        if(shareType == 'location') {
            Hafas.bind(this.Controller.ShareTrip.generateLocationShareLinks, this)();
        }
    },
    /**
     * prepare requests to retrieve the texts / links for the configured share options
     *
     * @method generateLocationShareLinks
     * @param {Function} callback - callback function that should be fired when rendering is done
     */
    generateLocationShareLinks: function(callback) {
        this.Controller.ShareTrip.shareModesLocation = Hafas.bind(this.Controller.ShareTrip.getShareModes,this)();
        var shareTripController = this.Controller.ShareTrip;
        let shareModes = this.Controller.ShareTrip.shareModesLocation;
        let currentConnection = this.Controller.ShareTrip.currentConnection;
        let currentLocation = this.Controller.ShareTrip.currentLocation;

        var shareLocationRequestFrames = [];
        for (var i = 0; i < shareModes.length; i++) {
            let currentShareMode = shareModes[i];

            // Create request frame
            var shareLocationRequest = Hafas.Core.newType('hafasHCIRequestObject', 'ShareLocation', {});

            // Add request parameters for location share
            shareLocationRequest.add('req.act','SRV');
            // For location share we always set the mode to "arrive"
            shareLocationRequest.add('req.frwd', false);
            // Contains lid of location to share
            shareLocationRequest.add('req.loc.lid', currentLocation.lid);
            // Contains the mode for sharing (e.g. TEXT_SMS, TEXT, TEXT_CAL)
            shareLocationRequest.add('req.modes', currentShareMode.mode);

            // If the user selected to add a date and time in the location share dialog, we need to send it as part of the request
            if(shareTripController.currentLocationShareUseTime && shareTripController.currentLocationShareTime.date && shareTripController.currentLocationShareTime.time){
               shareLocationRequest.add('req.date', shareTripController.currentLocationShareTime.date);
               shareLocationRequest.add('req.time', shareTripController.currentLocationShareTime.time);
            }
            shareLocationRequestFrames.push(shareLocationRequest);
        }

        var shareLocationHCIRequest = Hafas.Core.newType('hafasHCIRequest', {requests: shareLocationRequestFrames});

        Hafas.Core.newType("hafasRequest", {
            hciRequestObj: shareLocationHCIRequest,
            requestType: 'hci',
            callback: Hafas.bind(function (requestResult) {
                // We assign each in individual result and store it in the original available share modes
                for(var k = 0; k < this.Controller.ShareTrip.shareModesLocation.length; k++){
                    this.Controller.ShareTrip.shareModesLocation[k].res = requestResult.svcResL[k].res;
                }
                Hafas.bind(this.Controller.ShareTrip.showLocationShareLinks,this)(requestResult);
                if(typeof callback === 'function'){
                   callback();
                }
            }, this)
        });
    },
    /**
     * opens a location share overlay independently from the map flyout
     *
     * @method showLocationShare
     * @param {Object} data - contains a reference to an object keeper item
     * @param {String} data.objectKeeperReference - contains a reference to an object keeper item
     * @param {String} data.trigger - contains a reference to HTML Dom Element that triggered the call to open the popup
     */
    showLocationShare: function(data){
        var location = Hafas.Modules.Render.objectKeeper.get(data.objectKeeperReference);

        // Save the location as the "current" location to be used for location share
        this.Controller.ShareTrip.currentLocation = location;

        // Initialize "Now" Timestamp
        var nowAsHafasTimeObject = Hafas.Core.newType("hafasTime", {jsDate: new Date() });
        this.Controller.ShareTrip.currentLocationShareTime = {
            date: nowAsHafasTimeObject.getHCIDate(),
            time: nowAsHafasTimeObject.getHCITime()
        }

        Hafas.Modules.Render.render(
            {
                template: 'TP_AtomShareLocationFlyout',
                file: 'common.overlays.html',
                model: {
                    arrivalLocation: location
                }
            }, function (outputHTML) {
                this.Controller.ShareTrip.shareLocationOverlay = Hafas.Core.newType("HafasOverlay", {
                    app: this,
                    anchorElement: data.trigger.parentNode,
                    triggerElement: data.trigger,
                    anchoredOverlay: 'DESKTOP',
                    outputHTML: outputHTML,
                    forcePlacement: "above",
                    title: Hafas.Modules.i18n.get('ShareTrip.t_N_ShareLocationTitle'),
                    cssClass: 'lyr_locationSelectPopover lyr_shareOverlay',
                    closeViaCancel: true,
                    centerArrow: true,
                    onClose: function () {
                        // Reset the selected time for share location feature
                        Hafas.bind(this.Controller.ShareTrip.resetShareTime,this)();
                    }.bind(this)
                });
                // Initialize Date Time Picker
                Hafas.bind(this.Controller.ShareTrip.initShareLocationDateTimePicker, this)();

                // Initialize on blur events for "copy link" buttons
                this.Controller.ShareTrip.initLinkButtonsOnBlurEvents.bind(this)();

                // Generate the share links
                Hafas.bind(this.Controller.ShareTrip.generateLocationShareLinks, this)(function(){
                    //this.Controller.ShareTrip.shareLocationOverlay.updateAnchor();
                }.bind(this));
            }.bind(this));
    },
    /**
     * renders the links for the location share feature
     *
     * @method showLocationShareLinks
     * @param {Object} requestResult - HCI result set of prior "ShareLocation" bundled requests
     */
    showLocationShareLinks: function(requestResult){
        /* Assign result sets to the correct share mode */
        var shareUrl = "";
        for(var i = 0; i < this.Controller.ShareTrip.shareModesLocation.length;i++) {
            if(!shareUrl) {
                for (var j = 0; j < requestResult.svcResL.length; j++) {
                    let resultSet = requestResult.svcResL[j].res;
                    if (resultSet) {
                        let common = resultSet.common;
                        let texts = resultSet.texts;
                        var urlData = common?.urlL?.[texts?.[0]?.urlRef];
                        // We stop iterating, because we can use the first share URL from the response that we found
                        shareUrl = urlData?.url || "";
                        break;
                    }
                }
            }
        }

        // Create Buttons for Share Location
        Hafas.bind(this.Controller.ShareTrip.createShareButtons, this)(shareUrl, "Location");

        var input = Hafas("#HFS_ShareLocationLinkInput");
        if (input) {
            input.value = urlData?.url || "";
            input.onfocus = function () {
                Hafas.Util.gui.selectInputText(input);
            };
        }
    },
    /**
     * shows the share dialog/overlay
     *
     * @method showOverlay
     * @param {Object} data - function to be called after links has been received
     * @param {Number} data.arrayIdx - arrayIdx of the connection (index+1)
     * @param {String} data.type - cluster type
     */
    showOverlay: function (data) {
        var _me = this;

        var results = this.Controller.TP.instance.getResults(data.connectionType);
        var currConnection;
        this.Controller.ShareTrip.currentShortLink = null;

        if (Hafas.Modules.History)
            Hafas.Modules.History.addSubView("/GUI/shareTrip/closeOverlay", "ShareTripPopup", {});

        if (data.connectionType == 'PT') {
            currConnection = results[data.arrayIdx - 1];
        } else {
            currConnection = results[data.arrayIdx - 1].resolvedConnection;
        }

        // Save references to connection and current arrival location
        this.Controller.ShareTrip.currentConnection = currConnection;
        this.Controller.ShareTrip.currentLocation = currConnection.arr.locResolved;

        // Save current state of date and time to see if it has changed over time
        if(currConnection) {
            this.Controller.ShareTrip.currentLocationShareTime = {
                date: currConnection.date,
                time: currConnection.arr.aTimeS
            }
        }

        Hafas.Modules.Render.render(
            {
                template: 'TP_AtomShareTrip',
                file: 'common.overlays.html',
                model: {
                    connection: currConnection,
                    arrivalLocation: currConnection.arr.locResolved // holds reference to the arrival location
                }
            }, function (outputHTML) {
                var shareTripOverlayConfig = {
                    app: _me,
                    anchorElement: data.trigger,
                    anchoredOverlay: 'DESKTOP',
                    outputHTML: outputHTML,
                    cssClass: 'lyr_shareOverlay lyr_shareOverlayDetails',
                    closeViaCancel: true,
                    onClose: function () {
                        if (Hafas.Modules.History)
                            Hafas.Modules.History.removeCurrentStep("ShareTripPopup");
                    }
                };
                // If Share Location Feature is disabled we will show a headline because
                // the toggle switch is not available
                if(!Hafas.Config.Switches.useShareLocation){
                    shareTripOverlayConfig.title = Hafas.Modules.i18n.get('ShareTrip.t_N_OverlayTitle');
                }
                _me.Controller.ShareTrip.currentOverlay = Hafas.Core.newType("HafasOverlay", shareTripOverlayConfig);

                // Initialize on blur events for "copy link" buttons
                _me.Controller.ShareTrip.initLinkButtonsOnBlurEvents.bind(_me)();

                Hafas.bind(_me.Controller.ShareTrip.showLinkView, _me)();


                // Initialize Date Time Picker For Share Location Mode if activated
                if(Hafas.Config.Switches.useShareLocation) {
                    Hafas.bind(_me.Controller.ShareTrip.initShareLocationDateTimePicker,_me)();
                }

                // Tracking
                Hafas.ps.pub('/tracking/event/button-share', [{typ: 'event', key: 'button-share'}]);
                Hafas.ps.pub('/tracking/event/share-pressed', [{typ: 'event', key: 'share-pressed'}]);
            });
    },
    /**
     * inits inblur events for the "link copy" buttons so the hint after copying gets removed
     *
     * @method initLinkButtonsOnBlurEvents
     */
    initLinkButtonsOnBlurEvents: function(){
        var _me = this;
        var shortHintsIteratorAsArray = ["Trip"];
        if(Hafas.Config.Switches.useShareLocation){
            shortHintsIteratorAsArray.push("Location");
        }
        // Initialize onblur function when short hint for copied link appears
        for (var i = 0; i < shortHintsIteratorAsArray.length; i++) {
            let shortHintIterator = shortHintsIteratorAsArray[i];
            if(Hafas("#HFS_Share" + shortHintIterator + "LinkButton")) {
                Hafas("#HFS_Share" + shortHintIterator + "LinkButton").onblur = function (shortHintType) {
                    return function () {
                        var shortHint = Hafas("#HFS_Share" + shortHintType + "Link_ShortHint");
                        shortHint.innerHTML = "";
                        shortHint.removeClassName("OK");
                        shortHint.removeClassName("error");
                        // Update anchor for share location popup from flyout (if it exists)
                        if(_me.Controller.ShareTrip.shareLocationOverlay) {

                                _me.Controller.ShareTrip.shareLocationOverlay.updateAnchor();
                        }
                    }
                }(shortHintIterator);
            }
        }
    },
    /**
     * resets the time selected for sharing a location (will be called when opening share location
     * through the flyout)
     *
     * @method resetShareTime
     */
    resetShareTime: function(){
        this.Controller.ShareTrip.currentLocationShareTime = {
            date: null,
            time: null
        }
    },
    /**
     * inits the date time picker that is used in the ShareLocation functionality
     *
     * @method initShareLocationDateTimePicker
     * @returns {Object} returns an array of all available share modes
     */
    initShareLocationDateTimePicker: function() {
        let currentConnection = this.Controller.ShareTrip.currentConnection;

        // Init date time picker with out "now" mode
        let currentConfiguration = {
            isNowMode: false
        };

        if (currentConnection) {
            currentConfiguration.date = this.Controller.ShareTrip.currentLocationShareTime.date;
            currentConfiguration.time = this.Controller.ShareTrip.currentLocationShareTime.time;
        }

        // Setup config for date time picker
        var dateTimePickerConfig = {
            holder: "HFS_ShareLocationDateTimePickerHolder",
            id: "ShareLocationDTP",
            config: {
                useDepArrSwitch: false,
                useDateTexts: false,
                omitMask: true
            },
            current: currentConfiguration
        };

        // Initialize time date picker
        this.Controller.ShareTrip.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);
    },
    /**
     * callback when a user selects a time & date in location share date time picker
     * used to update the current time selection and automatically triggers a rerendering
     * of the share buttons because the time has changed
     *
     * @method selectDateTimeForLocationShare
     * @returns {String} hciDate date selected in HCI format
     * @returns {String} hciTime date selected in HCI format
     */
    selectDateTimeForLocationShare: function (hciDate, hciTime, enquiry, nowMode) {
        let shareLocationTimeData = this.Controller.ShareTrip.currentLocationShareTime;

        if (shareLocationTimeData.date != hciDate || shareLocationTimeData.time != hciTime || (nowMode && shareLocationTimeData.date != null && shareLocationTimeData.time != null)) {
            // Assign new values from date time picker selection
            var dateToApply = hciDate;
            var timeToApply = hciTime;
            if(nowMode){
                dateToApply = null;
                timeToApply = null;
            }
            this.Controller.ShareTrip.currentLocationShareTime.date = dateToApply;
            this.Controller.ShareTrip.currentLocationShareTime.time = timeToApply;
            Hafas.bind(this.Controller.ShareTrip.generateLocationShareLinks, this)();
        }

    },
    /**
     * toggle the usage of a date time picker for the location share
     *
     * @method toggleLocationShareTime
     * @returns {Object} returns an array of all available share modes
     */
    toggleLocationShareTime: function() {
        var shareTripController = this.Controller.ShareTrip;

        // Set the flag to indicate time should not be incorperated in HCI Share Request
        shareTripController.currentLocationShareUseTime = !shareTripController.currentLocationShareUseTime;

        // Set visibility of date time picker or hint text respectively
        Hafas.Util.gui.setVisibility(Hafas('#HFS_ShareLocationDateTimePickerHolder',false),shareTripController.currentLocationShareUseTime);
        Hafas.Util.gui.setVisibility(Hafas('#HFS_ShareLocationRemoveTime',false),shareTripController.currentLocationShareUseTime);
        Hafas.Util.gui.setVisibility(Hafas('#HFS_ShareLocationTimeHint',false),!shareTripController.currentLocationShareUseTime);

        // Links need to be regenerated
        Hafas.bind(this.Controller.ShareTrip.generateLocationShareLinks, this)();
    },
    /**
     * returns all relevant share modes as configured in the main config
     *
     * @method getShareModes
     * @returns {Object} returns an array of all available share modes
     */
    getShareModes: function(){
        var shareModes = [];
        var shareServices = this.Controller.ShareTrip.ShareServices;
        for (var service in shareServices) {
            var currentShareMode = shareServices[service].shareMode;
            var hasShareMode = false;
            for (var shIdx = 0; shIdx < shareModes.length; shIdx++) {
                if (shareModes[shIdx].mode == currentShareMode) {
                    hasShareMode = true;
                    shareModes[shIdx].services.push(service);
                }
            }
            if (!hasShareMode) {
                shareModes.push(
                    {
                        mode: currentShareMode,
                        services: [
                            service
                        ]
                    }
                );
            }
        }
        return shareModes;
    },
    /**
     * renders all share buttons after receiving the link
     *
     * @method showLinkView
     */
    showLinkView: function () {
        var me = this;
        var model = {};

        // Retrieve all share modes available/activated through the config
        me.Controller.ShareTrip.shareModeList = Hafas.bind(this.Controller.ShareTrip.getShareModes,this)();

        // Retrieve the short link from the server and render all links (buttons) afterwards
        Hafas.bind(me.Controller.ShareTrip.createShortLink, me)(function (hasLinkError, linkUrl) {
            var callback = function (results) {
                for (var i = 0; i < results.length; i++) {
                    me.Controller.ShareTrip.shareModeList[i].res = results[i].res;
                }
                Hafas.bind(me.Controller.ShareTrip.renderLinkView, me)(hasLinkError, linkUrl);
            };
            model.callback = callback;
            Hafas.bind(me.Controller.ShareTrip.requestShareLinks, me)(model);
        });

    },
    /**
     * request the short link for the "copy link" button from the server
     *
     * @method createShortLink
     * @param {Function} callback - function to be called after links has been received
     */
    createShortLink: function (callback) {
        // HCI 1.35 -> 1.39
        var ctxRecon = this.Controller.ShareTrip.currentConnection.ctxRecon || this.Controller.ShareTrip.currentConnection.recon.ctx;
        var shareTripReq = Hafas.Core.newType('hafasHCIRequestObject', 'ShareTrip', {
            'req.ctxRecon': ctxRecon,
      'req.mode': 'LINK'
        });

        // HCI >= 1.56 (req.modes)
        shareTripReq.add('req.modes', 'LINK');

        var shareTrip = Hafas.Core.newType('hafasHCIRequest', {requests: [shareTripReq]});

        Hafas.Core.newType("hafasRequest", {
            hciRequestObj: shareTrip,
            requestType: 'hci',
            callback: Hafas.bind(function (reqResult) {
                var errorStatus = false;
                var linkUrl = null;
                if (typeof reqResult.resultStatus == 'undefined' || typeof reqResult.resultStatus[0] == 'undefined' || reqResult.resultStatus[0].error) {
                    errorStatus = true;
                } else {
                    var result = reqResult.svcResL[0].res;
                    // In newer HCI Versions a "texts" array is being delivered in the response
                    if (result.texts !== undefined) {
                        for (var i = 0; i < result.texts.length; i++) {
                            var currentText = result.texts[i];
                            if (currentText.mode == 'LINK') {
                                linkUrl = result.common.urlL[currentText.urlRef].url;
                            }
                        }
                    } else {
                        linkUrl = result.common.urlL[result.urlL[0]].url;
                        this.Controller.ShareTrip.currentShortLink = linkUrl;
                    }
                }
                callback(errorStatus, linkUrl);
            }, this)
        });
    },

    /**
     * requests share links from the server
     *
     * @method requestShareLinks
     * @param {Object} params - HCI Response Result (svcResL[0].res)
     * @param {Function} params.callback - function to be called after share links have been received
     */
    requestShareLinks: function (params) {
        // HCI 1.35 -> 1.39
        var shareModes = [];
        var shareModeList = this.Controller.ShareTrip.shareModeList;
        for (var shIdx = 0; shIdx < shareModeList.length; shIdx++) {
            shareModes.push(shareModeList[shIdx].mode);
        }
        var connection = this.Controller.ShareTrip.currentConnection;
        var ctxRecon = connection.ctxRecon || connection.recon.ctx;
        var requestList = [];
        for (var modeIdx = 0; modeIdx < shareModes.length; modeIdx++) {
            var shareTripReq = Hafas.Core.newType('hafasHCIRequestObject', 'ShareTrip', {
                'req.ctxRecon': ctxRecon,
                'req.mode': shareModes[modeIdx]
            });
            // HCI >= 1.56 (req.modes)
            shareTripReq.add('req.modes', shareModes[modeIdx]);

            requestList.push(shareTripReq);
        }
        var shareTrip = Hafas.Core.newType('hafasHCIRequest', {requests: requestList});

        Hafas.Core.newType("hafasRequest", {
            hciRequestObj: shareTrip,
            requestType: 'hci',
            callback: Hafas.bind(function (reqResult) {
                var errorStatus = false;
                if (typeof reqResult.resultStatus == 'undefined' || typeof reqResult.resultStatus[0] == 'undefined' || reqResult.resultStatus[0].error || (reqResult.svcResL[0].res.text == undefined && reqResult.svcResL[0].res.texts == undefined)) {
                    errorStatus = true;
                } else {
                    var results = reqResult.svcResL;
                    params.callback(results);
                }
            }, this)
        });
    },
    /**
     * returns share result data (subject/text) for specific share type
     *
     * @method getShareDataFromResult
     * @param {Object} res - HCI Response Result (svcResL[0].res)
     * @param {String} shareMode - Share Mode, e.g. TEXT_SMS
     * @returns {Object} - Object containing "subject" and "text"
     */
    getShareDataFromResult: function (res, shareMode) {
        if (typeof res.texts != "undefined") {
            for (var i = 0; i < res.texts.length; i++) {
                var currentText = res.texts[i];
                if (currentText.mode == shareMode) {
                    return currentText;
                }
            }
            return null;
        } else {
            return {
                subject: res.subject,
                text: res.text
            }
        }
    },

    /**
     * opens a share link by type
     *
     * @method openShareLinkByType
     * @param {Object} params - HCI Response Result (svcResL[0].res)
     * @param {String} params.shareMode - Share Mode, e.g. TEXT_SMS
     * @param {String} params.shareChannel - Share Channel, e.g. WhatsApp, Twitter, Mail, FacebookMessenger, etc
     * @param {String} params.shareType - Share Type, e.g. "Trip" or "Location"
     */
    openShareLinkByType: function (params) {
        var shareResultData, model;
        var shareTripController = this.Controller.ShareTrip;
        var me = this;
        var shareMode = params.shareMode;
        var linkButtonType = shareTripController.ShareServices[params.shareChannel];
        if(params.shareType == 'Trip') {
            var shareModeList = shareTripController.shareModeList;
        }else{
            var shareModeList = shareTripController.shareModesLocation;
        }
        // Retrieve corresponding share trip result by comparing all results with specific mode id
        var shareTripResult = Hafas.Util.array.getEntryByPropertyValue(shareModeList, "mode", shareMode, false);

        if (shareTripResult.entry.res) {
            me.Controller.ShareTrip.currentConnectionText = shareTripResult.entry.res.text;
            // Retrieve text entrie of share trip results
            if (shareTripResult.entry.res.texts) {
                shareResultData = Hafas.Util.array.getEntryByPropertyValue(shareTripResult.entry.res.texts, "mode", shareMode, false);
                model = this.Controller.ShareTrip.createModel(shareResultData.entry.subject, shareResultData.entry.text, params.url)
            } else {
                model = this.Controller.ShareTrip.createModel(shareTripResult.entry.res.subject, shareTripResult.entry.res.text, params.url)
            }
            var href = linkButtonType.createHref(model);
            window.open(href);
        }
    },
    /**
     * Creates a QR code and renders the results in the result container for the share trip view
     * @method createQrCode
     * @param {string} linkUrl - link url that should be used for the qr code
     * @returns {string} A string representation of an SVG element.
     */
    createQrCode: function(linkUrl){
        Hafas('#HFS_ShareTripQrCode',false).innerHTML = Hafas.Util.createQrCodeString(linkUrl);
    },
    /**
     * creates all share buttons for ShareTrip sharing option
     *
     * @method createShareButtons
     * @param {String} linkUrl - contains the link URL if request was successful
     * @param {String} shareType - contains the type of sharing ("Trip" or "Location")
     */
    createShareButtons: function (linkUrl, shareType) {
        var buttonHolder = Hafas("#HFS_Share" + shareType + "LinkButtonHolder");
        var html = "";
        var isMobile = Hafas.Util.getPlatform().isMobile;
        for (var i = 0; i < Hafas.Config.Switches.useShareTrip.enabledLinkButtons.length; i++) {
            var type = Hafas.Config.Switches.useShareTrip.enabledLinkButtons[i];
            if (this.Controller.ShareTrip.ShareServices[type]) {
                var linkButtonType = this.Controller.ShareTrip.ShareServices[type];
                if (!isMobile && linkButtonType.onlyMobil)
                    continue;
                var model = {
                    text: Hafas.Modules.i18n.get(linkButtonType.text),
                    icnClass: linkButtonType.icnClass,
                    onclick: "Hafas.ps.pub('/GUI/share" + shareType + "/open', [{" +
                        "shareMode: '" + linkButtonType.shareMode + "', " +
                        "shareType: '" + shareType + "', "+
                        "shareChannel: '" + type + "', " +
                        "url: '" + linkUrl + "'}])"
                };
                html += Hafas.Modules.Render.renderTemplate("TP_ShareTripLinkButton", model);
            }
        }

        if (typeof navigator.share !== "undefined") {
            var type = "ShareAPI";
            if (this.Controller.ShareTrip.ShareServices[type]) {
                var linkButtonType = this.Controller.ShareTrip.ShareServices[type];
                var model = {
                    text: Hafas.Modules.i18n.get(linkButtonType.text),
                    icnClass: linkButtonType.icnClass,
                    onclick: "Hafas.ps.pub('/GUI/share" + shareType + "/shareWithAPI', [{shareType: '" + shareType + "'}]); return false;"
                };
                html += Hafas.Modules.Render.renderTemplate("TP_ShareTripLinkButton", model);
            }
        }

        if (buttonHolder) {
            buttonHolder.innerHTML = html;
        }
    },
    /**
     * copies the share URL of Trip or Location Share
     *
     * @method renderLinkView
     * @param {Boolean} hasError - holds the status of the last HCI request for retrieving the URLs
     * @param {String} linkUrl - contains the link URL if requests was successful
     * @param {String} title - contains the text for the share button's tooltip
     */
    renderLinkView: function (hasError, linkUrl, title) {
        if (hasError) {
            var resultTpl = 'TP_ShareTripError';
            var statusText = Hafas.Modules.i18n.get('ShareTrip.t_N_Error');
            Hafas("#HFS_ShareTripLinkCreateRow").innerHTML = Hafas.Modules.Render.renderTemplate(resultTpl, {statusText: statusText});
        } else {
            Hafas.Util.gui.setVisibility(Hafas("#HFS_ShareTripLinkCreateRow"), false);
            Hafas.Util.gui.setVisibility(Hafas("#HFS_ShareTripLinkSendRow"), true);
            var copyLinkBtn = Hafas("#HFS_ShareTripLinkButton");
            if (copyLinkBtn !== null) {
                copyLinkBtn.focus();
            }
            var input = Hafas("#HFS_ShareTripLinkInput");
            if (input) {
                input.value = linkUrl;
                input.onfocus = function () {
                    Hafas.Util.gui.selectInputText(input);
                };
            }
            if(Hafas.Config.Switches.useShareTrip.qrCode != "NONE") {
                Hafas.bind(this.Controller.ShareTrip.createQrCode, this)(linkUrl);
            }
            Hafas.bind(this.Controller.ShareTrip.createShareButtons, this)(linkUrl, "Trip");
            this.Controller.ShareTrip.currentOverlay.redraw(this.Controller.ShareTrip.currentOverlay);
        }
    },
    /**
     * copies the share URL of Trip or Location Share
     *
     * @method copyLInk
     * @param {Object} parameters - function to be called after links has been received
     * @param {Number} data.type - contains the type of sharing ("Trip" or "Location")
     */
    copyLink: function (parameters) {
        var inputHolder = Hafas("#HFS_shareInputHolder" + parameters.type);
        inputHolder.style.display = "";
        var inputElem = Hafas("#HFS_Share" + parameters.type + "LinkInput");
        if (!Hafas.Util.gui.hasFocus(inputElem)) {
            inputElem.focus();
        }
        inputElem.setSelectionRange(0, 99999);

        var succeeded;

        try {
            succeeded = document.execCommand("copy");
            inputHolder.style.display = "none";
        } catch (err) {
            succeeded = false;
        }
        var shortHint = Hafas("#HFS_Share" + parameters.type + "Link_ShortHint");
        if (succeeded) {
            shortHint.innerHTML = Hafas.Modules.i18n.get("ShareTrip.t_N_CopyDone");
            shortHint.addClassName("OK");
            Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('ShareTrip.t_N_CopyDone'));
        } else {
            shortHint.innerHTML = Hafas.Modules.i18n.get("ShareTrip.t_N_CopyFail");
            shortHint.addClassName("error");
            Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('ShareTrip.t_N_CopyFail'));
        }

        // Update anchor for share location popup from flyout (if it exists)
        if(this.Controller.ShareTrip.shareLocationOverlay) {
           this.Controller.ShareTrip.shareLocationOverlay.updateAnchor();
        }

        //Button fokussieren als Indikator, wann Bestätigung wieder ausgeblendet werden soll
        Hafas("#HFS_Share" + parameters.type + "LinkButton").focus();
    },
    /**
     * opens native share dialog
     *
     * @method shareWithAPI
     */
    shareWithAPI: function (params) {
        var model, shareTripResultEntry;
        var me = this;
        var linkButtonType = this.Controller.ShareTrip.ShareServices["ShareAPI"];
        var shareMode = linkButtonType.shareMode;
        // Retrieve corresponding share trip result by comparing all results with specific mode id, depending on shareType
        var shareModeList = (params.shareType === 'Trip') ? me.Controller.ShareTrip.shareModeList : me.Controller.ShareTrip.shareModesLocation;
        var shareTripResult = Hafas.Util.array.getEntryByPropertyValue(shareModeList, "mode", shareMode, false)
        shareTripResultEntry = shareTripResult.entry;
        if (shareTripResultEntry && shareTripResultEntry.res) {
            // Check if server sends new data structure
            if (shareTripResultEntry.res.texts !== undefined) {
                var textResult = Hafas.Util.array.getEntryByPropertyValue(shareTripResultEntry.res.texts, "mode", shareMode, false)
                if (textResult.entry !== undefined) {
                    shareTripResult = textResult.entry;
                    if(shareMode === 'LINK'){
                        var linkUrl = shareTripResultEntry.res.common?.urlL?.[shareTripResult.urlRef]?.url || "";
                        model = this.Controller.ShareTrip.createModel(shareTripResult.subject, null, linkUrl);
                    }
                    else {
                        model = this.Controller.ShareTrip.createModel(shareTripResult.subject, shareTripResult.text);
                    }
                }
            } else {
                shareTripResult = shareTripResult.entry.res;
                model = this.Controller.ShareTrip.createModel(shareTripResult.subject, shareTripResult.text)
            }
            navigator.share(model);
        }
    },

    ShareServices: {
        Mail: {
            text: "ShareTrip.t_N_MailButtonText",
            icnClass: "haf_share_mail",
            shareMode: "TEXT",
            onlyMobil: false,

            createHref: function (params) {
                var headerText = params.header;
                var bodyText = params.text;
                var href = "mailto:?subject=" + encodeURIComponent(headerText) + "&body=" + encodeURIComponent(bodyText);
                return href;
            }
        },
        SMS: {
            text: "ShareTrip.t_N_SMSButtonText",
            icnClass: "haf_share_sms",
            shareMode: "TEXT_SMS",
            onlyMobil: true,
            createHref: function (params) {
                var bodyText = params.text;
                var href = "sms:?&body=" + encodeURIComponent(bodyText);
                return href;
            }
        },
        WhatsApp: {
            text: "ShareTrip.t_N_WhatsAppButtonText",
            icnClass: "haf_share_whatsapp",
            shareMode: "TEXT_SMS",
            createHref: function (params) {
                var bodyText = params.text;
                var href = "https://api.whatsapp.com/send?text=" + encodeURIComponent(bodyText);
                return href;
            }
        },
        Twitter: {
            text: "ShareTrip.t_N_TwitterButtonText",
            icnClass: "haf_share_twitter",
            shareMode: "TEXT_SMS",
            onlyMobil: false,
            createHref: function (params) {
                var bodyText = params.text;
                var href = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(bodyText);
                return href;
            }
        },
        FacebookMessenger: {
            text: "ShareTrip.t_N_FacebookButtonText",
            icnClass: "haf_share_facebook_messenger",
            shareMode: "TEXT_CAL",
            onlyMobil: true,
            createHref: function (params) {
                var href = "fb-messenger://share/?link=" + encodeURIComponent(params.url);
                return href;
            }
        },
        Facebook: {
            text: "ShareTrip.t_N_FacebookButtonText",
            icnClass: "haf_share_fb",
            shareMode: "TEXT_CAL",
            onlyMobil: false,
            createHref: function (params) {
                var href = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(params.url);
                return href;
            }
        },
        ShareAPI: {
            text: "ShareTrip.t_N_ShareAPIButton",
            icnClass: "haf_share_other",
            shareMode: (navigator.userAgent.match(/Firefox/) && navigator.userAgent.match(/Android/)) ?  "LINK" : "TEXT_SMS",
            onlyMobil: true
        },
    },
    /**
     * closes the share dialog/overlay
     *
     * @method closeOverlay
     */
    closeOverlay: function () {
        if (this.Controller.ShareTrip.currentOverlay != null) {
            this.Controller.ShareTrip.currentOverlay.close();
        }
        this.Controller.ShareTrip.currentOverlay = null;
    }
};
